"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const Price = (0, app_1.styled)(app_1.Text) `
  font-size: ${(_, { $sale, $withInfo }) => $sale && $withInfo ? '1.5rem' : '0.875rem'};
  font-weight: 600;
  color: ${(theme, { $sale, $withInfo }) => $sale && $withInfo ? theme.colors.warning : theme.colors.secondary};
  line-height: 150%;
  letter-spacing: 0.175rem;
`;
const Discount = (0, app_1.styled)(Price) `
  color: ${(theme) => theme.colors.secondary};
  font-size: 0.75rem !important;
`;
const Strike = app_1.styled.s `
  color: ${(theme) => theme.colors.secondary.light};
`;
const PriceSkeleton = (0, app_1.styled)(ui_1.Skeleton) `
  min-width: 4rem;
`;
function ProductPriceView({ loading, price, quantity, lowestPriceBeforeSale, regularPrice, otherPrices, withInfo, className, }) {
    const { t } = (0, app_1.useTranslation)();
    const { locale } = (0, app_1.useTranslation)();
    const prefix = otherPrices ? 'Od ' : '';
    if (loading) {
        return (0, jsx_runtime_1.jsx)(PriceSkeleton, { rows: 1 });
    }
    return price ? ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ className: className, kind: "vertical", spacing: "0.1rem" }, { children: [(0, jsx_runtime_1.jsxs)(Price, Object.assign({ "$sale": Boolean(lowestPriceBeforeSale), "$withInfo": withInfo, tag: "span" }, { children: [prefix, (0, utils_1.formatPrice)((quantity !== null && quantity !== void 0 ? quantity : 1) * price, { locale })] })), lowestPriceBeforeSale ? ((0, jsx_runtime_1.jsxs)(Discount, Object.assign({ tag: "span" }, { children: [prefix, (0, jsx_runtime_1.jsx)(Strike, { children: (0, utils_1.formatPrice)(withInfo
                            ? lowestPriceBeforeSale
                            : regularPrice !== null && regularPrice !== void 0 ? regularPrice : lowestPriceBeforeSale, { locale }) }), ' ', withInfo ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('store.lowestPrice30Days') }) : null] }))) : null, withInfo && regularPrice ? ((0, jsx_runtime_1.jsxs)(Discount, Object.assign({ tag: "span" }, { children: [t.colon('store.regularPrice'), ' ', (0, jsx_runtime_1.jsx)(Strike, { children: (0, utils_1.formatPrice)(regularPrice, { locale }) })] }))) : null] }))) : null;
}
exports.ProductPriceView = ProductPriceView;
